import { createStore,applyMiddleware,compose } from 'redux'
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import logger from 'redux-logger'
import createReducer from './reducer';



// const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const store = createStore(rootReducer,composeEnhancer(applyMiddleware(logger)))


export default function configureStore(initialState = {}, history){
    let composeEnhancers = compose;
    const reduxSagaMonitorOptions = {};

    if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
        if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
          composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});

      }
      const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
      const middlewares = [sagaMiddleware, routerMiddleware(history),logger];
      const enhancers = [applyMiddleware(...middlewares)];

      const store = createStore(
          createReducer(),
        initialState,
        composeEnhancers(...enhancers),
      );

      return store;

}